<template>
<div class="cp_tabs">
    <div class="row">
        <div class="col-6">
            <div class="form-group">
                <input type="text" class="form-control" name="BankName" v-model="BankName" v-validate="'required'">
                <label class="labeltext">Bank Name</label>
                <span v-show="submitted && errors.has('BankName')" class="text-danger">Bank Name is required</span>
            </div>
        </div>
        <div class="col-6">
            <div class="form-group">
                <input type="text" class="form-control" name="Bank_Acc_Name" v-model="Bank_Acc_Name" v-validate="'required'">
                <label class="labeltext">Name on Bank Account</label>
                <span v-show="submitted && errors.has('Bank_Acc_Name')" class="text-danger">Name on Bank Account is required</span>
            </div>
        </div>
        <div class="col-6">
            <div class="form-group">
                <input type="text" class="form-control" name="BranchCode" v-model="BranchCode" v-validate="'required'">
                <label class="labeltext">Branch Code</label>
                <span v-show="submitted && errors.has('BranchCode')" class="text-danger">Branch Code is required</span>
            </div>
        </div>
        <div class="col-6">
            <div class="form-group">
                <input type="text" class="form-control" name="IBAN" v-model="IBAN" v-validate="'required'">
                <label class="labeltext">IBAN / Account Number</label>
                <span v-show="submitted && errors.has('IBAN')" class="text-danger">IBAN / Account Number is required</span>
            </div>
        </div>
        <div class="col-6">
            <div class="form-group">
                <input type="text" class="form-control" name="BIC" v-model="BIC" v-validate="'required'">
                <label class="labeltext">BIC/SWIFT Code</label>
                <span v-show="submitted && errors.has('BIC')" class="text-danger">BIC/SWIFT Code is required</span>
            </div>
        </div>
        <div class="col-6">
            <div class="form-group">
                <select class="form-control" name="Country" data-placeholder="Country" v-model="Country" v-validate="'required'">
                    <option data-countryCode="GB" value="44" Selected>Australia (+61)</option>
                    <option data-countryCode="US" value="1">UK (+44)</option>
                </select>
                <span v-show="submitted && errors.has('Country')" class="text-danger">Country Name is Required</span>
            </div>
        </div>

        <div class="col-12 text-center">
            <input type="submit" class="cap_btn blue" value="Add Now" @click.stop.prevent="BankTranFunc()">
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'bank',
    data() {
        return {
            pageLoader : false,
            submitted: false,
            
            BankName: '',
			Bank_Acc_Name: '',
			BranchCode: '',
			IBAN: '',
			BIC: '',
			Country: '',
        }
    },
    methods: {
        BankTranFunc(){
			const _that = this
			_that.submitted = true;
			_that.$validator.validate().then(valid => {
				if (valid) {
					console.log('abc1')
					let input_json={
						'globalParams' :{

						},
						'localParams' :{ "parameter" : _that }
					}
					_that.apiFunc(input_json)
				}
			});
		}
    },
}
</script>



// WEBPACK FOOTER //
// src/components/website/payment/methods/bank.vue